import React, { useState, useEffect } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Loader from '../../components/global/Loader';
import WidgetCompany from '../../components/global/WidgetCompany';
import NumberFormat from 'react-number-format';
import { useSelector } from 'react-redux';

import {
  getInventoryDetail,
  updateInventory,
  uploadImage,
} from '../../libs/apis';

function SellerIndex() {
  const { t } = useTranslation();
  const history = useHistory();
  const { inventoryId } = useParams();
  const { user } = useSelector(state => state.auth);
  const initialState = {
    data: null,
    isLoading: true,
    isError: false,
    id: inventoryId,
    name: '',
    price: '',
    priceVat: '',
    image: '',
    unit: '',
    vat: 24,
    vatExceed: false,
    type: 0,
    uploading: false,
    errorUpload: false,
    loading: false,
    error: false,
    categories: [],
    selectedCategory: null,
    errorMessage: '',
    gallery: [],
    company: null,
    is_company_active: true,
  };
  const [state, setMyState] = useState(initialState);
  const setState = newState => {
    setMyState(prevState => ({ ...prevState, ...newState }));
  };
  const {
    id,
    name,
    price,
    priceVat,
    type,
    unit,
    vat,
    vatExceed,
    image,
    loading,
    uploading,
    errorUpload,
    error,
    errorMessage,
    company,
    is_company_active,
  } = state;

  const isCompany = !!company;
  const myCompany = user.company;
  const isOwner = isCompany && myCompany && myCompany.id === company.id;

  useEffect(() => {
    const getData = async () => {
      const payload = {
        id: inventoryId,
      };
      await getInventoryDetail(payload)
        .then(resp => {
          if (resp.status === 200) {
            const p = resp.data.response;
            setState({ data: p });
            const priceWithVatInit =
              p.vat > 0 && p.price > 0
                ? p.price + Math.floor(p.price * (p.vat / 100) * 100) / 100
                : p.price;
            setState({
              name: p.name,
              price: p.price,
              priceVat: Number(priceWithVatInit),
              image: p.image,
              type: p.type || 0,
              unit: p.unit ? p.unit : '',
              vat: p.vat || 24,
              company: p.company || null,
              is_company_active: p.is_company_active || true,
            });
          }
        })
        .catch(err => {
          console.log('err', err);
          setState({ error: true });
        })
        .finally(() => setState({ loading: false }));
    };
    getData();
  }, [inventoryId]);

  const handleSubmit = async ev => {
    ev.preventDefault();
    setState({ loading: true, error: false, errorMessage: '' });
    const payload = {
      id,
      name,
      price,
      image,
      type,
      unit,
      vat,
      is_company_active: is_company_active,
    };
    await updateInventory(payload)
      .then(resp => {
        if (resp.status === 201 || resp.status === 200) {
          history.push('/seller/inventory');
        } else {
          console.log('re', resp);
          setState({ error: true, errorMessage: resp.data.error.message });
        }
      })
      .catch(err => {
        console.log('err', err);
        setState({ error: true, errorMessage: err.error.message });
      })
      .finally(() => {
        setState({ loading: false });
      });
  };

  const onDropImage = async e => {
    const file = e.target.files;
    setState({ uploading: true, errorUpload: false, image: '' });

    const payload = {
      file: file[0],
    };
    await uploadImage(payload)
      .then(res => {
        if (res.status === 200) {
          const resized = res.data.secure_url.replace(
            'https://res.cloudinary.com/luokki/image/upload/',
            'https://res.cloudinary.com/luokki/image/upload/w_300,h_300,c_fill/',
          );
          setState({ image: resized });
        }
      })
      .catch(err => {
        setState({ errorUpload: true });
        console.log('err', err);
      })
      .finally(() => {
        setState({ uploading: false });
      });
  };

  const canEdit = !isCompany || isOwner;

  return (
    <div className="admin-container">
      <div className="admin-header bg-primary bg-gradient py-3 sticky-top shadow-sm">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="admin-header-content d-flex justify-content-between align-items-center">
                <Link
                  to="/seller/inventory"
                  className="text-light text-decoration-none"
                >
                  <span className="fa fa-chevron-left me-2"></span>
                  <span className="text">{t('back_button')}</span>
                </Link>
                <h6 className="text-light m-0">{t('seller_admin')}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="main-container py-4 pb-5">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="content text-left">
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="small text-primary text-uppercase fw-bold mb-0">
                    {t('edit_inventory_heading')}
                  </h4>
                </div>
                <p>
                  <span className="text-danger">*</span>{' '}
                  {t('warning_mandatory_text')}
                </p>
                {isCompany && (
                  <div className="alert alert-primary p-2 mb-3">
                    <h6 className="small mb-2 text-primary">
                      <span className="fa fa-building me-2"></span>
                      {t('com_inventory_owner')}
                    </h6>
                    <WidgetCompany data={company} />
                  </div>
                )}
                <hr />

                <div className="form-container">
                  {error && (
                    <div className="alert alert-danger fade show" role="alert">
                      {errorMessage}
                    </div>
                  )}
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      {/* <ImageUploader
                        singleImage={true}
                        withIcon={true}
                        buttonText='Choose images'
                        onChange={onDrop}
                        imgExtension={['.jpg', '.gif', '.png', '.gif']}
                        maxFileSize={5242880}
                      />
                      <input type="hidden" name="photo" value={photo} /> */}

                      <div className="form-floating mb-3">
                        <select
                          className="form-select "
                          name="category"
                          value={type}
                          onChange={e =>
                            setState({ type: parseInt(e.target.value) })
                          }
                          disabled={loading || !canEdit}
                        >
                          <option value={0}>{t('item_label')}</option>
                          <option value={1}>{t('work_label')}</option>
                        </select>
                        <label htmlFor="category">
                          {t('select_category')}{' '}
                          <span className="text-danger">*</span>
                        </label>
                      </div>
                      {errorUpload && (
                        <div className="alert alert-danger text-center">
                          <p className="m-0">{t('failed_to_upload')}</p>
                        </div>
                      )}
                      {uploading && <Loader size={24} />}
                      <div className="image-uploader text-center">
                        {image && (
                          <div className="mb-3 d-flex justify-content-center">
                            <img
                              src={image}
                              alt="upload"
                              className="img-thumbnail"
                            />
                          </div>
                        )}

                        <label
                          htmlFor="img"
                          className={`position-relative w-100 d-flex align-items-center mb-3 btn ${
                            uploading || !canEdit
                              ? 'btn-secondary opacity-50'
                              : 'btn-primary'
                          }`}
                        >
                          <span className="fa fa-image me-3"></span>
                          {image ? (
                            <small>
                              {t('change_image')}{' '}
                              <span className="text-danger">*</span>
                            </small>
                          ) : (
                            <small>
                              {t('upload_image')}{' '}
                              <span className="text-danger">*</span>
                            </small>
                          )}
                          {image ? (
                            <input
                              type="file"
                              accept="image/*"
                              id="img"
                              onChange={onDropImage}
                              className="fs-6 small"
                              disabled={uploading || !canEdit}
                              style={{
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                right: '0',
                                bottom: '0',
                                opacity: 0,
                              }}
                            />
                          ) : (
                            <input
                              type="file"
                              id="img"
                              accept="image/*"
                              onChange={onDropImage}
                              className="fs-6 small"
                              required
                              disabled={uploading || !canEdit}
                              style={{
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                right: '0',
                                bottom: '0',
                                opacity: 0,
                              }}
                            />
                          )}
                        </label>
                      </div>
                    </div>
                    <div className="form-floating mb-3">
                      <input
                        className="form-control"
                        type="text"
                        id="name"
                        value={name}
                        onChange={e => setState({ name: e.target.value })}
                        disabled={loading || !canEdit}
                        required
                        placeholder={t('inventory_name_label')}
                      />
                      <label htmlFor="name">
                        {t('inventory_name_label')}{' '}
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="form-floating input-group mb-3">
                      <span className="input-group-text">/</span>
                      <input
                        className="form-control"
                        type="text"
                        id="unit"
                        value={unit}
                        onChange={e => setState({ unit: e.target.value })}
                        disabled={loading || !canEdit}
                        required
                        placeholder={t('inventory_unit_label')}
                      />
                      <label htmlFor="unit" style={{ left: '2em' }}>
                        {t('inventory_unit_label')}{' '}
                        <span className="text-danger">*</span>
                      </label>
                    </div>

                    <div className="form-floating input-group mb-3">
                      <span className="input-group-text">{t('$')}</span>
                      <NumberFormat
                        className="form-control"
                        id="price"
                        value={price}
                        required
                        decimalScale={2}
                        onChange={e => {
                          const value = Number(e.target.value);
                          let newVatPrice = priceVat;
                          if (!isNaN(value)) {
                            newVatPrice = value + (value * vat) / 100;
                          }
                          setState({
                            price: value,
                            priceVat: newVatPrice,
                          });
                        }}
                        onValueChange={({ floatValue }) => {
                          setState({
                            price: floatValue,
                          });
                        }}
                        disabled={loading}
                        placeholder={t('inventory_price_label')}
                      />
                      <label htmlFor="price" style={{ left: '2em' }}>
                        {t('inventory_price_label')}{' '}
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="form-floating input-group mb-3">
                      <span className="input-group-text">{t('$')}</span>
                      <NumberFormat
                        className="form-control"
                        id="priceVat"
                        value={priceVat}
                        required
                        decimalScale={2}
                        onChange={e => {
                          const value = Number(e.target.value);
                          const vatPercent = vat / 100;
                          let newPrice = price;
                          if (!isNaN(value)) {
                            newPrice = value / (1 + vatPercent);
                          }
                          setState({ priceVat: value, price: newPrice });
                        }}
                        onValueChange={({ floatValue }) => {
                          setState({ priceVat: floatValue });
                        }}
                        disabled={loading}
                        placeholder={t('inventory_price_inc_label')}
                      />
                      <label htmlFor="priceVat" style={{ left: '2em' }}>
                        {t('inventory_price_inc_label')}
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="form-floating mb-3 input-group">
                      <input
                        className={`form-control ${
                          vatExceed ? 'is-invalid' : ''
                        }`}
                        type="text"
                        id="vat"
                        value={vat}
                        required
                        step="1"
                        min="0"
                        max="100"
                        pattern="\d*"
                        onChange={e => {
                          const val = e.target.value;
                          const newVal = val === '' ? 0 : val;
                          const vatVal = parseInt(newVal);
                          if (vatVal > 100) {
                            setState({ vatExceed: true });
                          } else {
                            setState({ vatExceed: false });
                          }
                          const percentVat = vatVal / 100;
                          const priceWithVat =
                            Math.floor((price + price * percentVat) * 100) /
                            100;
                          setState({
                            vat: vatVal,
                            priceVat: priceWithVat,
                          });
                        }}
                        disabled={loading}
                        placeholder={`${t('inventory_vat_label')} (0-100%)`}
                      />

                      <label htmlFor="vat">
                        {`${t('inventory_vat_label')} (0-100%)`}
                        <span className="text-danger">*</span>
                      </label>
                      <span className="input-group-text">%</span>
                    </div>
                    {vatExceed || price === 0 || priceVat === 0 || uploading ? (
                      <button
                        type="button"
                        className="btn btn-lg btn-secondary w-100 mb-3"
                        disabled
                      >
                        {t('save_button')}{' '}
                        <span className="ms-2 fa fa-chevron-right"></span>
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-lg btn-primary w-100 mb-3"
                      >
                        {t('save_button')}{' '}
                        <span className="ms-2 fa fa-chevron-right"></span>
                      </button>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SellerIndex;
